import {
  DashboardOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { AuthRoles, AuthSubscriptions } from '@hefe/auth';
import {
  ClubSubscriptionEnum,
  GeneralClubSettingFunctionType,
  GeneralClubSettingFunctionTypeEnum,
} from '@hefe/models';
import { FiUsers } from 'react-icons/fi';

export interface NavItem {
  title?: boolean;
  name: string;
  url: string;
  icon?: any;
  auth: string[];
  subscription: ClubSubscriptionEnum[];
  children?: NavItem[];
  userSection?: boolean;
  teamSection?: boolean;
  disabled?: boolean;
  /* Show menu item only if club setting is enabled */
  generalClubFunctionType?: GeneralClubSettingFunctionTypeEnum;
}

export default {
  items: [
    {
      title: true,
      name: 'dashboard',
      url: '/dashboard',
      icon: <DashboardOutlined />,
      auth: AuthRoles.bbuser,
      subscription: AuthSubscriptions.free,
    },
    {
      name: 'schedule',
      url: '/season/schedule',
      icon: 'fa fa-list',
      auth: AuthRoles.bbuser,
      subscription: AuthSubscriptions.free,
    },
    /**************************************************************************************/
    {
      title: true,
      name: 'Mein Bereich',
      url: '/user',
      icon: <UserOutlined />,
      auth: AuthRoles.bbuser,
      subscription: AuthSubscriptions.free,
      userSection: true,
      children: [
        {
          name: 'my_events',
          url: '/user/events',
          icon: 'fa fa-list',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'messages.plural',
          url: '/user/messages',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'switch_requests.plural',
          url: '/user/switchrequests',
          icon: 'fa fa-refresh',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.first,
        },
        {
          name: 'coach_logging',
          url: '/user/coachlogging',
          icon: 'fa fa-pencil',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.second,
        },
      ],
    },
    /**************************************************************************************/
    {
      title: true,
      name: 'my_team',
      url: '/team',
      icon: <TeamOutlined />,
      auth: AuthRoles.bbcoach,
      subscription: AuthSubscriptions.free,
      teamSection: true,
      children: [
        {
          name: 'players',
          url: '/team/players',
          icon: 'fa fa-users',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'events.plural',
          url: '/team/events',
          icon: 'fa fa-list',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'messages.plural',
          url: '/team/messages',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'tasks.plural',
          url: '/team/admin/tasks',
          icon: 'fa fa-hand-paper-o',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'settings.title',
          url: '/team/admin/settings',
          icon: 'fa fa-cog',
          auth: AuthRoles.bbcoach,
          subscription: AuthSubscriptions.first,
        },
      ],
    },
    /**************************************************************************************/
    {
      title: true,
      name: 'club',
      url: '/club',
      icon: <SettingOutlined />,
      auth: AuthRoles.bbuser,
      subscription: AuthSubscriptions.free,
      children: [
        {
          name: 'Trainingszeiten',
          url: '/season/practice-times',
          icon: 'fa fa-list',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'knowledge_base.title',
          url: '/knowledge-base',
          icon: 'fa fa-list',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.first,
        },
        {
          name: 'statistics.plural',
          url: '/statistics',
          icon: 'fa fa-statistics',
          auth: AuthRoles.bbuser,
          subscription: AuthSubscriptions.free,
        },
      ],
    },
    /**************************************************************************************/
    {
      title: true,
      name: 'season',
      url: '/season',
      icon: <SettingOutlined />,
      auth: AuthRoles.bbadmin,
      subscription: AuthSubscriptions.free,
      children: [
        /*{
          name: 'operations_center.title',
          url: '/season/operations-center',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },*/
        {
          name: 'gameday_planer.title',
          url: '/season/gameday',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'practices.administration.title',
          url: '/season/practices',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'gyms.closures.title',
          url: '/season/gym-closures',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'events.events.plural',
          url: '/season/events',
          icon: 'fa fa-list',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        /*
        {
          name: 'season_planer.title',
          url: '/season/planer',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
          disabled: true,
        },
        {
          name: 'coach_conflicts',
          url: '/season/coaches-conflicts',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
          disabled: true,
        },
        */
      ],
    },
    /**************************************************************************************/
    {
      title: true,
      name: 'administration',
      url: '/admin',
      icon: <SettingOutlined />,
      auth: AuthRoles.bbadmin,
      subscription: AuthSubscriptions.free,
      children: [
        {
          name: 'messages.plural',
          url: '/admin/messages',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
          disabled: false,
        },
        {
          name: 'tasks.plural',
          url: '/admin/tasks',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
          icon: 'fa fa-envelope',
          disabled: false,
        },
        {
          name: 'inventory.plural',
          url: '/admin/inventory',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.second,
          icon: 'fa fa-envelope',
          disabled: false,
        },
        {
          name: 'members',
          url: '/admin/users',
          icon: <FiUsers />,
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'teams',
          url: '/admin/teams',
          icon: <FiUsers />,
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'gyms.plural',
          url: '/admin/gyms',
          icon: 'fa fa-building',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'leagues.plural',
          url: '/admin/leagues',
          icon: 'fa fa-trophy',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
        {
          name: 'cars.plural',
          url: '/admin/cars',
          icon: 'fa fa-car',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.second,
        },
        {
          name: 'partners.plural',
          url: '/admin/partners',
          icon: 'fa fa-handshake',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.third,
          generalClubFunctionType: GeneralClubSettingFunctionType.PARTNERS,
        },
        {
          name: 'club',
          url: '/admin/club',
          icon: 'fa fa-envelope',
          auth: AuthRoles.bbadmin,
          subscription: AuthSubscriptions.free,
        },
      ],
    },
  ] as NavItem[],
};
